import * as model from "./model";

const productAssignmentDefaultRecord = () => ({
    [model.PROPS_ACTIVE_YN]: true,
    [model.PROPS_CROP_CLASS_NAME]: "",
    [model.PROPS_CROP_LIST]: [],
    [model.PROPS_CROP_NAME]: "",
    [model.PROPS_ERROR_MESSAGE]: null,
    [model.PROPS_IS_ACTIVE]: true,
    [model.PROPS_SAMPLE_TYPE_GUID]: "",
    [model.PROPS_SAMPLE_TYPE_NAME]: "",
    [model.PROPS_PRODUCT_ASSIGNMENT_GUID]: null,
    [model.PROPS_NUTRIENT_NAME]: "",
    [model.PROPS_NUTRIENT_GUID]: "",
    [model.PROPS_ORG_LEVEL_LIST]: [],
    [model.PROPS_ORG_LEVEL_NAME]: "",
    [model.PROPS_PRODUCT_LIST]: [],
    [model.PROPS_SYSTEM_ATTRIBUTE_GUID]: "",
    [model.PROPS_SYSTEM_ATTRIBUTE_NAME]: "",
    [model.PROPS_IRRIGATION_CATEGORY_GUID]: "",
    [model.PROPS_IRRIGATION_CATEGORY]: "",
    [model.PROPS_WATER_PURPOSE_GUID]: "",
    [model.PROPS_WATER_PURPOSE]: "",
});

export default productAssignmentDefaultRecord;
